import React from 'react';
import { useHistory } from 'react-router-dom';
import useAppView from 'Hooks/useAppView';
import useUser from 'Hooks/useUser';
import StickyBanner from 'elements/StickyBanner';
import Colors from 'modules/Colors';

interface AdminTeamViewBannerProps {
    className?: string;
}

const AdminTeamViewBanner: React.FC<AdminTeamViewBannerProps> = ({ className }) => {
    const history = useHistory();
    const { isAdminTeamView, adminTeamData, exitAdminTeamView, setAppView } = useAppView();
    const { isSymphonyAdmin } = useUser();

    const handleExitTeamView = () => {
        exitAdminTeamView();
        setAppView('brand', history);
    };

    return (
        <StickyBanner
            className={`adminTeamViewBanner ${className || ''}`}
            show={isSymphonyAdmin && isAdminTeamView() && !!adminTeamData}
            backgroundColor={Colors.purpleLight}
            borderColor={Colors.purple}
            textColor={Colors.purple}
            icon="🔧"
            mainText="Admin Team View"
            subtitleText={adminTeamData ? `Viewing team: ${adminTeamData.organizationName}` : undefined}
            primaryButton={{
                text: 'Exit Team View',
                onClick: handleExitTeamView,
                variant: 'outlined',
                color: 'purple',
                size: 'small',
                style: {
                    borderColor: Colors.purple,
                    color: Colors.purple,
                    backgroundColor: 'white'
                }
            }}
        />
    );
};

export default AdminTeamViewBanner;
